import './UserProfile.css';
import { withAuthenticator } from '@aws-amplify/ui-react';
import React from "react";

const UserProfile = ({ signOut, user }) => {

    const username = (user.signInDetails.loginId) ? user.signInDetails.loginId : "email not found"

    return (
        <div className="userProfile">
            <p className="userProfileHeaderText"> ACCOUNT DETAILS: </p>
            <p className="userProfileText"> account email: {username} </p>
            <p className="userProfileSignOutButton" onClick={signOut}>sign out</p>
        </div>
    )
}

export default withAuthenticator(UserProfile);